/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const DEFAULT_UPLOAD_STATUS = {
    status: "NOT_STARTED",
    message: "The upload has not started.",
};

export const MODES = {
    UPLOAD: "upload",
    SELECT: "select",
    SELECT_PREVIEW: "select_and_preview",
    EDIT: "edit",
};
export const startingMode = MODES.SELECT;

export const EDIT_TABS = {
    PROPERTIES: "properties",
    PLACEMENTS: "placements",
};
export const EDIT_TABS_INDEX = {
    PROPERTIES: 0,
    PLACEMENTS: 1,
};
export const startingEditTab = EDIT_TABS_INDEX.PROPERTIES;
